module.exports = __webpack_public_path__ + "img/insta.751a308e.png";